import { isAuthorized } from "components/Authorize/authorizeUtil";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import { activityStatuses } from "features/activity/activityConsts";
import { sum } from "lodash";
import FormatService from "services/formatService";
import GraphHeader from "../GraphHeader/GraphHeader";
import { workorderDashboardPageStyles } from "../WorkorderDashboardPageStyles";
import { Tooltip as MuiTooltip } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const WorkorderCostTotal = ({ workorders }) => {
    const classes = workorderDashboardPageStyles();

    //Charge is masked to 0 server-side for vendors, so they get their own internal cost instead
    const canSeeCharge = isAuthorized(permissionProfiles.ACTIVITY.CHARGE_VIEW);
    const completed = workorders?.filter(a => a.activityStatus == activityStatuses.Completed) ?? [];
    const total = sum(completed?.map(a => canSeeCharge ? a.revenue : a.price) ?? []);

    return (
        <div style={{ height: 350 }}>
            <GraphHeader 
                title={'Total Cost'} 
                rightContent={
                    <MuiTooltip title={canSeeCharge
                        ? "This value is the charge for all completed activities in the selected month"
                        : "This value is the internal cost for all completed activities in the selected month"}>
                        <InfoOutlinedIcon />
                    </MuiTooltip>
                }
            />
            <div className={classes.totalCost}>
                {FormatService.formatCurrency(total)}
            </div>
        </div>
    )
}

export default WorkorderCostTotal;
